// extracted by css-extract-rspack-plugin
export default {"licenseTokenStep":"tHtlB"};